import { request } from "services/api/util";
const END_POINT = "systemStatus";
class SystemService {
  async getListSystemStatus() {
    const config = {
      method: "get",
      url: `${END_POINT}/getSystemStatus`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}
export default new SystemService();
